<!-- 新闻详情 -->
<template> 
    <div class="news-wrap">
        <PageBack :title="title" />
        <div class="detail-description">
            <div class="detail-des-title">
                <div class="center">
                    <img src="../../assets/images/icon-step.png" alt="" class="icon-step"> 
                    <span class="detail-pro-title">{{ ruleForm.newsTitle }}</span>
                </div>
                <div class="news-date">
                    <span>发布人：{{ ruleForm.username }}</span><span class="pd-l-20">发布日期：{{ ruleForm.date }}</span>
                </div>
                <div class="ql-editor" v-html="ruleForm.des"></div>
            </div>
        </div>
    </div>
</template>

<script>
import PageBack from '@/components/PageHeader'
export default {
    name: 'newsDetail',
    data() {
        return {
            newsId: '',
            ruleForm: {},
            status: 0,
        }
    },
    components:{
        PageBack
    },
    created() {
        this.newsId = this.$route.query.id
        this.status = this.$route.query.status || ''
    },
    mounted() {
        if(this.newsId){
            this.initData()
        }
    },
    computed:{
        title(){
            return this.$route.meta.title
        }    
    },
    methods: {
        initData(){
        let params = {
            opcode: this.$code.NewsQuery,
            i_serial: this.newsId,
            v_title: '', 
            c_status: this.status,              
            start_date: 0,
            end_date: 0,
            pagesize: 10,
            page: 1,        
        }
        this.$api._requestAPI(params).then(res=>{
            if(res.IsSuccess){
                let result = res.Data.DataTable 
                if(result.length > 0){
                    let list = result.map(item=>{
                        let jsonDa = JSON.stringify(item['详情']).replace(/<img/gi, 
                        "<img class='richImg' style='max-width:100%;'");
                        var newResData = JSON.parse(jsonDa);  
                        let des = this.$help.replaceHttpWithHttps(newResData)
                        return{
                            // imageUrl: this.$global.uploadUrl + item['图片'],
                            newsTitle: item['标题'],
                            intro: item['简介'],
                            username: item['发布人'],
                            date: this.$help.formatDate(item['日期']),
                            des: des,
                        }
                    })   
                    this.ruleForm = {...list[0]}  
                }     
            }
        })
    },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.news-wrap{
    width: 78vw;
    min-height: 800px;
    margin: 0 auto;
    margin-top: 10px;
    // border: 1px solid red;
}
.news-date{
    text-align: center;
    margin-top: 20px;
}
.news-img{
    width: 100%;
}
.detail-pro-des{
    white-space: pre-wrap;
}
.ql-editor img{
    width: 100% !important;
}
</style>


// WEBPACK FOOTER //
// src/views/news/newsDetail.vue